import propTypes from 'prop-types';

import { CallUs } from './CallUs.jsx';
import Subtotal from './Subtotal.jsx';
import { ObsoletePriceMsg } from './ObsoletePriceMsg.jsx';

const _PriceCell = ({ item, measure }) => {
  const obsoleteMsg = item.isObsolete && (<ObsoletePriceMsg />);
  const showCallUs = !item.isObsolete && (<CallUs />);

  return (
    <>
      {(item.price && item.currency)
        ? (<Subtotal item={item} measure={measure} />) 
        : showCallUs}
      {obsoleteMsg ? obsoleteMsg: null}
    </>
  );
};

_PriceCell.propTypes = {
  item: propTypes.shape({
    price: propTypes.oneOfType([
      propTypes.number,
      propTypes.string
    ]),
    subtotal: propTypes.number,
    currency: propTypes.string,
    isObsolete: propTypes.bool
  }),
  measure: propTypes.string
};

export const PriceCell = (_PriceCell);
